﻿import React from "react";
import type { Content } from "@measured/puck";
import { withLayoutCommon, getLayoutCommonRootProps } from "@digitalopsdev/serviceops-docs-components/dist/blocks/LayoutCommonMixin";
import { withGap, getGapRootProps } from "@digitalopsdev/serviceops-docs-components/dist/blocks/GapMixin";

// ActivityRow renders a responsive grid using Tailwind responsive prefixes.
// - Mobile-first: 2 columns by default (grid-cols-2)
// - Desktop (lg ≥ 1024px): switches to `columns` (lg:grid-cols-N)
// Gap maps to Tailwind spacing scale when possible; otherwise falls back to inline style.
const ActivityRow = {
  fields: {
    content: { type: "slot" as const },
    columns: { type: "number" as const }
  },
  defaultProps: {
    columns: 4,
    content: [] as Content
  },
  render: (props: any) => {
    const { content: Content, columns = 4 } = props as any;
    const baseCols = Math.max(1, Number(columns) || 4);

    // Map numeric column count to explicit Tailwind class names so JIT picks them up.
    const LG_COLS: Record<number, string> = {
      1: "lg:grid-cols-1",
      2: "lg:grid-cols-2",
      3: "lg:grid-cols-3",
      4: "lg:grid-cols-4",
      5: "lg:grid-cols-5",
      6: "lg:grid-cols-6",
      7: "lg:grid-cols-7",
      8: "lg:grid-cols-8",
      9: "lg:grid-cols-9",
      10: "lg:grid-cols-10",
      11: "lg:grid-cols-11",
      12: "lg:grid-cols-12"
    };

    const className = ["grid", "grid-cols-2", LG_COLS[baseCols] || "lg:grid-cols-4"]
      .filter(Boolean)
      .join(" ");

    const style: React.CSSProperties = {};

    // Merge Layout Common (padding/margin/font-size), then Gap mixin
    const rootLC = getLayoutCommonRootProps(props, { className, style });
    const rootProps = getGapRootProps(props, rootLC);

    return <Content {...rootProps} />;
  }
};

export default withLayoutCommon(withGap(ActivityRow));